import { type FC } from 'react'
import { type SchedulingEventType } from '../../../models/Scheduling'

type PlacementInput = Pick<SchedulingEventType, 'active' | 'accountPageVisible'>

interface PlacementChipsProps {
  eventType: PlacementInput
}

interface ChipProps {
  icon: string
  children: string
}

const Chip: FC<ChipProps> = ({ icon, children }) => (
  <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-extra-small zocks-text-gray-600'>
    <i className={`bi ${icon}`} aria-hidden='true' />
    {children}
  </span>
)

export const PlacementChips: FC<PlacementChipsProps> = ({ eventType }) => {
  const onAccountPage = Boolean(eventType.accountPageVisible)
  if (!onAccountPage && !eventType.active) {
    return <Chip icon='bi-circle'>Not live</Chip>
  }
  return (
    <span className='d-inline-flex align-items-center flex-wrap gap-3'>
      {onAccountPage ? <Chip icon='bi-people-fill'>Account booking page</Chip> : null}
      {eventType.active ? <Chip icon='bi-person-fill'>Individual booking pages</Chip> : null}
    </span>
  )
}
